export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7324.05f22e56.jpg";